/**
 * @flow
 * @relayHash 344d3bee19e1c32238b3623abe03370a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FeeDeleteMutationVariables = {|
  feeId: string
|};
export type FeeDeleteMutationResponse = {|
  +deleteFee: ?{|
    +feeTemplate: ?{|
      +id: string,
      +fees: {|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string
          |}
        |}>
      |},
    |}
  |}
|};
export type FeeDeleteMutation = {|
  variables: FeeDeleteMutationVariables,
  response: FeeDeleteMutationResponse,
|};
*/


/*
mutation FeeDeleteMutation(
  $feeId: ID!
) {
  deleteFee(feeId: $feeId) {
    feeTemplate {
      id
      fees {
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "feeId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteFee",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "feeId",
        "variableName": "feeId"
      }
    ],
    "concreteType": "DeleteFee",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "feeTemplate",
        "storageKey": null,
        "args": null,
        "concreteType": "FeeTemplateNode",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "fees",
            "storageKey": null,
            "args": null,
            "concreteType": "FeeNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "FeeNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FeeNode",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FeeDeleteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "FeeDeleteMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "FeeDeleteMutation",
    "id": null,
    "text": "mutation FeeDeleteMutation(\n  $feeId: ID!\n) {\n  deleteFee(feeId: $feeId) {\n    feeTemplate {\n      id\n      fees {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '17546f7b99682935211136ca47d0e4a2';
module.exports = node;
